import React from 'react';
import RegisteredClasses1 from '../../../assets/img/award/registered-classes-1.png';
import RegisteredClasses2 from '../../../assets/img/award/registered-classes-2.png';
import SampleImagePage from './sample-image-page';

const styles = {
  card: 'w-[60%] self-stretch p-2 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-brand-cyan inline-flex flex-col justify-start items-start',
  title: 'justify-start text-blue text-3xl font-normal font-serif leading-4',
  introSection: 'self-stretch text-xl',
  introSectionTitle: 'text-xl mb-2',
  imageStyle: 'outline outline-1 outline-offset-[-0.2px] outline-gray',
};

const RegisteredClassesSample = () => {
  return (
    <SampleImagePage
      cardClassName={styles.card}
      titleClassName={styles.title}
      sectionClassName={styles.introSection}
      sectionTitleClassName={styles.introSectionTitle}
      items={[
        { title: 'Sample One', src: RegisteredClasses1, alt: 'Registered Classes Sample 1', width: '80%' },
        {
          title: 'Sample Two',
          src: RegisteredClasses2,
          alt: 'Registered Classes Sample 2',
          width: '80%',
          sectionClassName: 'pb-4',
          imageStyle: { outline: '4px solid #D1D5DB', outlineOffset: '-2px' },
        },
      ]}
    />
  );
};

export default RegisteredClassesSample;
